/* =====================================================================
   Sheodra Wishlist — heart buttons (UI layer)
   ---------------------------------------------------------------------
   This file NEVER touches localStorage. It only talks to the storage
   module (window.SheodraWishlist). That is what will let us swap the
   storage for a real backend later without changing a single button.

   A heart is any element with class .wl-heart carrying:
     data-wl-handle        product handle          (required)
     data-wl-variant       variant id, or empty    (optional)
     data-wl-track-variant present = follow the product page's variant picker
     data-label-off/on     label text for each state
   ===================================================================== */
(function (w, d) {
  'use strict';

  /* If this file is included twice (e.g. header AND a section), a second run would
     register a SECOND click listener — one click would then toggle the heart twice
     and cancel itself out. Guard against it. */
  if (w.__sheodraWishlistUi) return;
  /* Also the public surface: a page that injects cards after load (the category's Load More)
     calls repaint() so the new hearts show their saved state. paintAll is hoisted. */
  w.__sheodraWishlistUi = { repaint: paintAll };

  var BOOT_STYLE_ID = 'ijcWlBoot';

  function api() {
    return w.SheodraWishlist;
  }

  function keyOf(btn) {
    var v = btn.getAttribute('data-wl-variant') || '';
    return btn.getAttribute('data-wl-handle') + ':' + v;
  }

  /* A card heart carries no variant (nothing was chosen yet), so it works at PRODUCT level:
     it means "this piece is in my list", whatever metal/size. Product-page hearts stay
     variant-level (silver and gold are different pieces at different prices). */
  function isProductLevel(btn) {
    return btn.hasAttribute('data-wl-product-level');
  }

  function paint(btn) {
    var wl = api();
    if (!wl) return;
    var saved = isProductLevel(btn)
      ? wl.hasProduct(btn.getAttribute('data-wl-handle'))
      : wl.has(keyOf(btn));
    if (btn.classList.contains('is-saved') !== saved) {
      btn.classList.toggle('is-saved', saved);
    }
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var label = btn.querySelector('.wl-heart__label');
    if (label) {
      label.textContent = saved
        ? btn.getAttribute('data-label-on') || 'Saved'
        : btn.getAttribute('data-label-off') || 'Save';
    }
  }

  /* Any element with [data-wl-count] shows how many pieces are saved (the header badge).
     It is hidden while the list is empty. */
  function paintCount() {
    var wl = api();
    if (!wl) return;
    var n = wl.count();
    var badges = d.querySelectorAll('[data-wl-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = n > 0 ? String(n) : '';
      badges[i].classList.toggle('is-on', n > 0);
    }
  }

  function paintAll() {
    var hearts = d.querySelectorAll('.wl-heart');
    for (var i = 0; i < hearts.length; i++) paint(hearts[i]);
    paintCount();
  }

  /* The inline boot script forced the "saved" look before the first paint, so a saved
     item never blinks. Now that we can drive it with classes, drop that <style> and
     paint the real state IN THE SAME TASK — the browser cannot repaint in between,
     so there is no flicker at the handover. */
  function takeOver() {
    var boot = d.getElementById(BOOT_STYLE_ID);
    if (boot && boot.parentNode) boot.parentNode.removeChild(boot);
    paintAll();
  }

  /* Delegated: works for hearts that appear later (cards, wishlist page). */
  d.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.wl-heart') : null;
    if (!btn) return;
    /* Card hearts sit INSIDE the card's <a>. Without this the click would follow the link
       and navigate to the product instead of saving it. */
    e.preventDefault();
    e.stopPropagation();
    var wl = api();
    if (!wl) return;
    var handle = btn.getAttribute('data-wl-handle');

    if (isProductLevel(btn)) {
      /* Un-hearting a card drops the piece in every metal/size it was saved in. */
      if (wl.hasProduct(handle)) wl.removeProduct(handle);
      else wl.add({ h: handle, v: null });
    } else {
      var v = btn.getAttribute('data-wl-variant');
      wl.toggle({ h: handle, v: v || null });
    }
    /* no repaint here on purpose — it arrives via the wishlist:change event below,
       which keeps EVERY heart and the counter in sync from one place. */
  });

  /* Metal / size changed on the product page: this heart now refers to another variant. */
  w.addEventListener('ijc:variant:change', function (e) {
    var id = e && e.detail ? e.detail.id : null;
    var hearts = d.querySelectorAll('.wl-heart[data-wl-track-variant]');
    for (var i = 0; i < hearts.length; i++) {
      hearts[i].setAttribute('data-wl-variant', id == null ? '' : String(id));
      paint(hearts[i]);
    }
  });

  /* Single source of truth for repainting: the list changed, so every heart re-checks. */
  w.addEventListener('wishlist:change', paintAll);

  if (d.readyState !== 'loading') takeOver();
  else d.addEventListener('DOMContentLoaded', takeOver);
})(window, document);
